import { useMemo } from 'react'
import Icon from 'components/Icon'
import Type from 'components/Type'
import CircleFrame from 'components/CommonUI/CircleFrame'
import ModalView from 'components/CommonUI/ModalView'
import Stack from '@mui/material/Stack'

const DestinationsNotCovered = ({
  excludedDestinations,
}) => {
  const [
    columnLeft,
    columnRight,
  ] = useMemo(() => {
    const half = Math.ceil(excludedDestinations.length / 2)
    return [excludedDestinations.slice(0, half), excludedDestinations.slice(half)]
  }, [excludedDestinations])

  return (
    <ModalView
      sizeX="lg"
    >
      <Stack
        display="inline-grid"
        p={3}
      >
        <CircleFrame
          justifySelf="center"
          mb={2}
        >
          <Icon
            icon="CelCancelDestination"
          />
        </CircleFrame>
        <Type
          variant="sectionLabel"
          textAlign="center"
          mb={1}
        >
          Destinations not covered
        </Type>
        <Type
          variant="p"
          textAlign="center"
          mb={3}
        >
          At this time, the battleface Multi-Trip Annual Plan does not offer coverage when you travel to:
        </Type>
        <Stack
          display="grid"
          gridTemplateColumns={{
            xs: 'repeat(2, 1fr)',
          }}
          gap={1.5}
        >
          <Stack
            display="inline-grid"
            gap={1.5}
          >
            {columnLeft.map(o => (
              <Stack
                key={o}
                sx={theme => theme.internalMixins.columns({ gap: 1 })}
              >
                <Icon
                  icon="ErrorSmallDuo"
                />
                <Type
                  variant="dataSmall"
                  color="neutralCool_700"
                >
                  {o}
                </Type>
              </Stack>
            ))}
          </Stack>
          <Stack
            display="inline-grid"
            gap={1.5}
          >
            {columnRight.map(o => (
              <Stack
                key={o}
                sx={theme => theme.internalMixins.columns({ gap: 1 })}
              >
                <Icon
                  icon="ErrorSmallDuo"
                />
                <Type
                  variant="dataSmall"
                  color="neutralCool_700"
                >
                  {o}
                </Type>
              </Stack>
            ))}
          </Stack>
        </Stack>
      </Stack>
    </ModalView>
  )
}

export default DestinationsNotCovered